import React from 'react'
import moment from 'moment'

import { Heading } from '../Heading'
import { SectionOverride } from 'layout'
import { linkTo, primaryDate } from 'event-taxonomy'

import EventSingle from './EventSingle'

// Scans the whole collection rather than trusting the first and last entries:
// session sales carry advertised_start_date instead of start_at, so a mixed
// collection is not necessarily sorted by the date we display.
const findRange = (collection) => {
  const dates = collection
    .map(primaryDate)
    .filter(Boolean)
    .map(date => moment(date))
    .filter(date => date.isValid())

  if (dates.length === 0) return null

  const firstDate = moment.min(dates)
  const lastDate = moment.max(dates)

  return firstDate.isSame(lastDate, 'year')
    ? firstDate.format('YYYY')
    : `${firstDate.format('YYYY')} - ${lastDate.format('YYYY')}`
}

const EventCollection = (props) => {
  let { collection, range } = props
  let rangeCopy

  if (range && collection && collection.length) {
    rangeCopy = findRange(collection)
  }

  collection = (
    collection.map((single, index) => {
      const { target } = single

      if (single.type === 'session_sale') {
        return (
          <EventSingle
            key={index}
            id={target.id}
            type={single.type}
            subtype={target.type}
            title={target.title}
            to={linkTo(single)}
            start={target.advertised_start_date}
            end={target.advertised_end_date}
            registered={target.registration_status === 'reserved'}
          />
        )
      } else if (single.type === 'webinar') {
        return (
          <EventSingle
            key={index}
            id={target.id}
            type={single.type}
            subtype={target.type}
            title={target.title}
            to={linkTo(single)}
            start={target.start_at}
            end={target.end_at}
            facilitator={target.facilitator}
            registered={target.registered}
            showTimes
          />
        )
      } else {
        return null
      }
    })
  )

  return (
    <div>
      {
        rangeCopy &&
          <SectionOverride>
            <Heading>{rangeCopy}</Heading>
          </SectionOverride>
      }
      {collection}
    </div>
  )
}

EventCollection.propTypes = {
  collection: React.PropTypes.arrayOf(React.PropTypes.shape({
    type: React.PropTypes.string.isRequired,
    target: React.PropTypes.object.isRequired
  })).isRequired,
  range: React.PropTypes.bool
}

export default EventCollection
